// extracted by mini-css-extract-plugin
export default {"tableArea":"Sk12nDYIuMFC5LTkl9F8"};